{
    "v": "5.7.4",
    "fr": 24,
    "ip": 0,
    "op": 72,
    "w": 500,
    "h": 500,
    "nm": "26-Key",
    "ddd": 0,
    "assets": [],
    "layers": [
        {
            "ddd": 0,
            "ind": 1,
            "ty": 3,
            "nm": "Main Stroke width - Color Ctrl",
            "sr": 1,
            "ks": {
                "o": { "a": 0, "k": 100, "ix": 11 },
                "r": { "a": 0, "k": 0, "ix": 10 },
                "p": { "a": 0, "k": [250, 250, 0], "ix": 2, "l": 2 },
                "a": { "a": 0, "k": [250, 250, 0], "ix": 1, "l": 2 },
                "s": { "a": 0, "k": [100, 100, 100], "ix": 6, "l": 2 }
            },
            "ao": 0,
            "ef": [
                {
                    "ty": 5,
                    "nm": "Stroke width",
                    "np": 3,
                    "mn": "ADBE Slider Control",
                    "ix": 1,
                    "en": 1,
                    "ef": [
                        {
                            "ty": 0,
                            "nm": "Slider",
                            "mn": "ADBE Slider Control-0001",
                            "ix": 1,
                            "v": { "a": 0, "k": 24, "ix": 1 }
                        }
                    ]
                },
                {
                    "ty": 5,
                    "nm": "Base Color",
                    "np": 3,
                    "mn": "ADBE Color Control",
                    "ix": 2,
                    "en": 1,
                    "ef": [
                        {
                            "ty": 2,
                            "nm": "Color",
                            "mn": "ADBE Color Control-0001",
                            "ix": 1,
                            "v": {
                                "a": 0,
                                "k": [0, 0, 0, 1],
                                "ix": 1,
                                "x": "var $bm_rt;\n$bm_rt = effect('Base Color')('Color');"
                            }
                        }
                    ]
                },
                {
                    "ty": 5,
                    "nm": "Highlight",
                    "np": 3,
                    "mn": "ADBE Color Control",
                    "ix": 3,
                    "en": 1,
                    "ef": [
                        {
                            "ty": 2,
                            "nm": "Color",
                            "mn": "ADBE Color Control-0001",
                            "ix": 1,
                            "v": {
                                "a": 0,
                                "k": [0.157, 0.176, 0.212, 1],
                                "ix": 1,
                                "x": "var $bm_rt;\n$bm_rt = effect('Highlight')('Color');"
                            }
                        }
                    ]
                }
            ],
            "ip": 0,
            "op": 72,
            "st": 0,
            "bm": 0
        },
        {
            "ddd": 0,
            "ind": 2,
            "ty": 4,
            "nm": "26-Key",
            "sr": 1,
            "ks": {
                "o": { "a": 0, "k": 100, "ix": 11 },
                "r": {
                    "a": 1,
                    "k": [
                        {
                            "i": { "x": [0.25], "y": [1] },
                            "o": { "x": [0.167], "y": [0.167] },
                            "t": 1,
                            "s": [0]
                        },
                        {
                            "i": { "x": [0.833], "y": [0.833] },
                            "o": { "x": [0.75], "y": [0] },
                            "t": 22,
                            "s": [63]
                        },
                        {
                            "i": { "x": [0.25], "y": [1] },
                            "o": { "x": [0.167], "y": [0] },
                            "t": 37,
                            "s": [44]
                        },
                        {
                            "i": { "x": [0.25], "y": [1] },
                            "o": { "x": [0.75], "y": [0] },
                            "t": 52,
                            "s": [44]
                        },
                        { "t": 71, "s": [0] }
                    ],
                    "ix": 10
                },
                "p": {
                    "a": 1,
                    "k": [
                        {
                            "i": { "x": 0.25, "y": 1 },
                            "o": { "x": 0.167, "y": 0.167 },
                            "t": 1,
                            "s": [250, 250, 0],
                            "to": [-7.167, 0, 0],
                            "ti": [-2.167, 0, 0]
                        },
                        {
                            "i": { "x": 0.833, "y": 0.833 },
                            "o": { "x": 0.75, "y": 0 },
                            "t": 22,
                            "s": [207, 250, 0],
                            "to": [2.167, 0, 0],
                            "ti": [-9.333, 0, 0]
                        },
                        {
                            "i": { "x": 0.25, "y": 0.25 },
                            "o": { "x": 0.167, "y": 0.167 },
                            "t": 37,
                            "s": [263, 250, 0],
                            "to": [0, 0, 0],
                            "ti": [0, 0, 0]
                        },
                        {
                            "i": { "x": 0.25, "y": 1 },
                            "o": { "x": 0.75, "y": 0 },
                            "t": 52,
                            "s": [263, 250, 0],
                            "to": [-2.167, 0, 0],
                            "ti": [2.167, 0, 0]
                        },
                        { "t": 71, "s": [250, 250, 0] }
                    ],
                    "ix": 2,
                    "l": 2
                },
                "a": { "a": 0, "k": [250, 250, 0], "ix": 1, "l": 2 },
                "s": { "a": 0, "k": [100, 100, 100], "ix": 6, "l": 2 }
            },
            "ao": 0,
            "shapes": [
                {
                    "ty": "gr",
                    "it": [
                        {
                            "ind": 0,
                            "ty": "sh",
                            "ix": 1,
                            "ks": {
                                "a": 1,
                                "k": [
                                    {
                                        "i": { "x": 0.25, "y": 1 },
                                        "o": { "x": 0.167, "y": 0.167 },
                                        "t": 1,
                                        "s": [
                                            {
                                                "i": [
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 0]
                                                ],
                                                "o": [
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 0]
                                                ],
                                                "v": [
                                                    [50.871, -16.955],
                                                    [16.937, -50.871],
                                                    [-50.871, 16.961],
                                                    [-16.937, 50.871]
                                                ],
                                                "c": true
                                            }
                                        ]
                                    },
                                    {
                                        "i": { "x": 0.833, "y": 0.833 },
                                        "o": { "x": 0.167, "y": 0.167 },
                                        "t": 22,
                                        "s": [
                                            {
                                                "i": [
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 0]
                                                ],
                                                "o": [
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 0]
                                                ],
                                                "v": [
                                                    [-8.534, 9.718],
                                                    [-31.553, -13.289],
                                                    [-77.55, 32.725],
                                                    [-54.532, 55.728]
                                                ],
                                                "c": true
                                            }
                                        ]
                                    },
                                    {
                                        "i": { "x": 0.833, "y": 0.833 },
                                        "o": { "x": 0.167, "y": 0.167 },
                                        "t": 39,
                                        "s": [
                                            {
                                                "i": [
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 0]
                                                ],
                                                "o": [
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 0]
                                                ],
                                                "v": [
                                                    [-8.534, 9.718],
                                                    [-31.553, -13.289],
                                                    [-77.55, 32.725],
                                                    [-54.532, 55.728]
                                                ],
                                                "c": true
                                            }
                                        ]
                                    },
                                    {
                                        "i": { "x": 0.833, "y": 0.833 },
                                        "o": { "x": 0.167, "y": 0.167 },
                                        "t": 45,
                                        "s": [
                                            {
                                                "i": [
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 0]
                                                ],
                                                "o": [
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 0]
                                                ],
                                                "v": [
                                                    [-18.954, -1.072],
                                                    [-31.553, -13.289],
                                                    [-77.55, 32.725],
                                                    [-64.951, 44.938]
                                                ],
                                                "c": true
                                            }
                                        ]
                                    },
                                    {
                                        "i": { "x": 0.833, "y": 0.833 },
                                        "o": { "x": 0.167, "y": 0.167 },
                                        "t": 50,
                                        "s": [
                                            {
                                                "i": [
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 0]
                                                ],
                                                "o": [
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 0]
                                                ],
                                                "v": [
                                                    [-8.534, 9.718],
                                                    [-31.553, -13.289],
                                                    [-77.55, 32.725],
                                                    [-54.532, 55.728]
                                                ],
                                                "c": true
                                            }
                                        ]
                                    },
                                    {
                                        "i": { "x": 0.25, "y": 1 },
                                        "o": { "x": 0.75, "y": 0 },
                                        "t": 53,
                                        "s": [
                                            {
                                                "i": [
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 0]
                                                ],
                                                "o": [
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 0]
                                                ],
                                                "v": [
                                                    [-8.534, 9.718],
                                                    [-31.553, -13.289],
                                                    [-77.55, 32.725],
                                                    [-54.532, 55.728]
                                                ],
                                                "c": true
                                            }
                                        ]
                                    },
                                    {
                                        "t": 71,
                                        "s": [
                                            {
                                                "i": [
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 0]
                                                ],
                                                "o": [
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 0]
                                                ],
                                                "v": [
                                                    [50.871, -16.955],
                                                    [16.937, -50.871],
                                                    [-50.871, 16.961],
                                                    [-16.937, 50.871]
                                                ],
                                                "c": true
                                            }
                                        ]
                                    }
                                ],
                                "ix": 2
                            },
                            "nm": "Path 1",
                            "mn": "ADBE Vector Shape - Group",
                            "hd": false
                        },
                        {
                            "ty": "st",
                            "c": {
                                "a": 0,
                                "k": [0, 0, 0, 1],
                                "ix": 3,
                                "x": "var $bm_rt;\n$bm_rt = thisComp.layer('Main Stroke width - Color Ctrl').effect('Base Color')('Color');"
                            },
                            "o": { "a": 0, "k": 100, "ix": 4 },
                            "w": {
                                "a": 0,
                                "k": 22,
                                "ix": 5,
                                "x": "var $bm_rt;\n$bm_rt = thisComp.layer('Main Stroke width - Color Ctrl').effect('Stroke width')('Slider');"
                            },
                            "lc": 1,
                            "lj": 2,
                            "bm": 0,
                            "nm": "Stroke 1",
                            "mn": "ADBE Vector Graphic - Stroke",
                            "hd": false
                        },
                        {
                            "ty": "tr",
                            "p": { "a": 0, "k": [378.993, 188.841], "ix": 2 },
                            "a": { "a": 0, "k": [0, 0], "ix": 1 },
                            "s": { "a": 0, "k": [100, 100], "ix": 3 },
                            "r": { "a": 0, "k": 0, "ix": 6 },
                            "o": { "a": 0, "k": 100, "ix": 7 },
                            "sk": { "a": 0, "k": 0, "ix": 4 },
                            "sa": { "a": 0, "k": 0, "ix": 5 },
                            "nm": "Transform"
                        }
                    ],
                    "nm": "Group 1",
                    "np": 2,
                    "cix": 2,
                    "bm": 0,
                    "ix": 1,
                    "mn": "ADBE Vector Group",
                    "hd": false
                },
                {
                    "ty": "gr",
                    "it": [
                        {
                            "ind": 0,
                            "ty": "sh",
                            "ix": 1,
                            "ks": {
                                "a": 1,
                                "k": [
                                    {
                                        "i": { "x": 0.25, "y": 1 },
                                        "o": { "x": 0.167, "y": 0.167 },
                                        "t": 1,
                                        "s": [
                                            {
                                                "i": [
                                                    [0, 0],
                                                    [24.522, -24.521],
                                                    [-38.55, -38.592],
                                                    [-28.958, 28.94],
                                                    [23.621, 36.188],
                                                    [0, 0],
                                                    [0, 0]
                                                ],
                                                "o": [
                                                    [-36.212, -23.568],
                                                    [-28.957, 28.94],
                                                    [38.611, 38.586],
                                                    [24.521, -24.521],
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 0]
                                                ],
                                                "v": [
                                                    [-56.295, 22.399],
                                                    [-160.555, 24.893],
                                                    [-147.845, 147.835],
                                                    [-24.879, 160.551],
                                                    [-22.421, 56.315],
                                                    [179.864, -145.946],
                                                    [145.93, -179.862]
                                                ],
                                                "c": true
                                            }
                                        ]
                                    },
                                    {
                                        "i": { "x": 0.833, "y": 0.833 },
                                        "o": { "x": 0.167, "y": 0.167 },
                                        "t": 22,
                                        "s": [
                                            {
                                                "i": [
                                                    [0, 0],
                                                    [16.639, -16.629],
                                                    [-26.173, -26.157],
                                                    [-19.637, 19.638],
                                                    [16.024, 24.548],
                                                    [0, 0],
                                                    [0, 0]
                                                ],
                                                "o": [
                                                    [-24.565, -15.987],
                                                    [-19.643, 19.631],
                                                    [26.192, 26.175],
                                                    [16.634, -16.634],
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 0]
                                                ],
                                                "v": [
                                                    [-39.74, 16.742],
                                                    [-110.465, 18.434],
                                                    [-101.843, 101.832],
                                                    [-18.429, 110.458],
                                                    [-16.761, 39.749],
                                                    [120.459, -97.455],
                                                    [97.44, -120.462]
                                                ],
                                                "c": true
                                            }
                                        ]
                                    },
                                    {
                                        "i": { "x": 0.833, "y": 0.833 },
                                        "o": { "x": 0.167, "y": 0.167 },
                                        "t": 39,
                                        "s": [
                                            {
                                                "i": [
                                                    [0, 0],
                                                    [16.639, -16.629],
                                                    [-26.173, -26.157],
                                                    [-19.637, 19.638],
                                                    [16.024, 24.548],
                                                    [0, 0],
                                                    [0, 0]
                                                ],
                                                "o": [
                                                    [-24.565, -15.987],
                                                    [-19.643, 19.631],
                                                    [26.192, 26.175],
                                                    [16.634, -16.634],
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 0]
                                                ],
                                                "v": [
                                                    [-39.74, 16.742],
                                                    [-110.465, 18.434],
                                                    [-101.843, 101.832],
                                                    [-18.429, 110.458],
                                                    [-16.761, 39.749],
                                                    [120.459, -97.455],
                                                    [97.44, -120.462]
                                                ],
                                                "c": true
                                            }
                                        ]
                                    },
                                    {
                                        "i": { "x": 0.833, "y": 0.833 },
                                        "o": { "x": 0.167, "y": 0.167 },
                                        "t": 45,
                                        "s": [
                                            {
                                                "i": [
                                                    [0, 0],
                                                    [13.334, -13.326],
                                                    [-26.173, -26.157],
                                                    [-15.736, 15.737],
                                                    [16.024, 24.548],
                                                    [0, 0],
                                                    [0, 0]
                                                ],
                                                "o": [
                                                    [-24.565, -15.987],
                                                    [-15.741, 15.732],
                                                    [26.192, 26.175],
                                                    [13.33, -13.33],
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 0]
                                                ],
                                                "v": [
                                                    [-39.74, 16.742],
                                                    [-101.622, 27.873],
                                                    [-101.843, 101.832],
                                                    [-27.869, 101.617],
                                                    [-16.761, 39.749],
                                                    [120.459, -97.455],
                                                    [97.44, -120.462]
                                                ],
                                                "c": true
                                            }
                                        ]
                                    },
                                    {
                                        "i": { "x": 0.833, "y": 0.833 },
                                        "o": { "x": 0.167, "y": 0.167 },
                                        "t": 50,
                                        "s": [
                                            {
                                                "i": [
                                                    [0, 0],
                                                    [16.639, -16.629],
                                                    [-26.173, -26.157],
                                                    [-19.637, 19.638],
                                                    [16.024, 24.548],
                                                    [0, 0],
                                                    [0, 0]
                                                ],
                                                "o": [
                                                    [-24.565, -15.987],
                                                    [-19.643, 19.631],
                                                    [26.192, 26.175],
                                                    [16.634, -16.634],
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 0]
                                                ],
                                                "v": [
                                                    [-39.74, 16.742],
                                                    [-110.465, 18.434],
                                                    [-101.843, 101.832],
                                                    [-18.429, 110.458],
                                                    [-16.761, 39.749],
                                                    [120.459, -97.455],
                                                    [97.44, -120.462]
                                                ],
                                                "c": true
                                            }
                                        ]
                                    },
                                    {
                                        "i": { "x": 0.25, "y": 1 },
                                        "o": { "x": 0.75, "y": 0 },
                                        "t": 53,
                                        "s": [
                                            {
                                                "i": [
                                                    [0, 0],
                                                    [16.639, -16.629],
                                                    [-26.173, -26.157],
                                                    [-19.637, 19.638],
                                                    [16.024, 24.548],
                                                    [0, 0],
                                                    [0, 0]
                                                ],
                                                "o": [
                                                    [-24.565, -15.987],
                                                    [-19.643, 19.631],
                                                    [26.192, 26.175],
                                                    [16.634, -16.634],
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 0]
                                                ],
                                                "v": [
                                                    [-39.74, 16.742],
                                                    [-110.465, 18.434],
                                                    [-101.843, 101.832],
                                                    [-18.429, 110.458],
                                                    [-16.761, 39.749],
                                                    [120.459, -97.455],
                                                    [97.44, -120.462]
                                                ],
                                                "c": true
                                            }
                                        ]
                                    },
                                    {
                                        "t": 71,
                                        "s": [
                                            {
                                                "i": [
                                                    [0, 0],
                                                    [24.522, -24.521],
                                                    [-38.55, -38.592],
                                                    [-28.958, 28.94],
                                                    [23.621, 36.188],
                                                    [0, 0],
                                                    [0, 0]
                                                ],
                                                "o": [
                                                    [-36.212, -23.568],
                                                    [-28.957, 28.94],
                                                    [38.611, 38.586],
                                                    [24.521, -24.521],
                                                    [0, 0],
                                                    [0, 0],
                                                    [0, 0]
                                                ],
                                                "v": [
                                                    [-56.295, 22.399],
                                                    [-160.555, 24.893],
                                                    [-147.845, 147.835],
                                                    [-24.879, 160.551],
                                                    [-22.421, 56.315],
                                                    [179.864, -145.946],
                                                    [145.93, -179.862]
                                                ],
                                                "c": true
                                            }
                                        ]
                                    }
                                ],
                                "ix": 2
                            },
                            "nm": "Path 1",
                            "mn": "ADBE Vector Shape - Group",
                            "hd": false
                        },
                        {
                            "ty": "st",
                            "c": {
                                "a": 0,
                                "k": [0, 0, 0, 1],
                                "ix": 3,
                                "x": "var $bm_rt;\n$bm_rt = thisComp.layer('Main Stroke width - Color Ctrl').effect('Base Color')('Color');"
                            },
                            "o": { "a": 0, "k": 100, "ix": 4 },
                            "w": {
                                "a": 0,
                                "k": 22,
                                "ix": 5,
                                "x": "var $bm_rt;\n$bm_rt = thisComp.layer('Main Stroke width - Color Ctrl').effect('Stroke width')('Slider');"
                            },
                            "lc": 1,
                            "lj": 2,
                            "bm": 0,
                            "nm": "Stroke 1",
                            "mn": "ADBE Vector Graphic - Stroke",
                            "hd": false
                        },
                        {
                            "ty": "tr",
                            "p": { "a": 0, "k": [250, 250], "ix": 2 },
                            "a": { "a": 0, "k": [0, 0], "ix": 1 },
                            "s": { "a": 0, "k": [100, 100], "ix": 3 },
                            "r": { "a": 0, "k": 0, "ix": 6 },
                            "o": { "a": 0, "k": 100, "ix": 7 },
                            "sk": { "a": 0, "k": 0, "ix": 4 },
                            "sa": { "a": 0, "k": 0, "ix": 5 },
                            "nm": "Transform"
                        }
                    ],
                    "nm": "Group 2",
                    "np": 2,
                    "cix": 2,
                    "bm": 0,
                    "ix": 2,
                    "mn": "ADBE Vector Group",
                    "hd": false
                },
                {
                    "ty": "gr",
                    "it": [
                        {
                            "ind": 0,
                            "ty": "sh",
                            "ix": 1,
                            "ks": {
                                "a": 1,
                                "k": [
                                    {
                                        "i": { "x": 0.25, "y": 1 },
                                        "o": { "x": 0.167, "y": 0.167 },
                                        "t": 1,
                                        "s": [
                                            {
                                                "i": [
                                                    [-10.012, -10.042],
                                                    [-1.618, -11.529],
                                                    [5.336, -5.354],
                                                    [8.214, 1.169],
                                                    [10.013, 10.042],
                                                    [1.619, 11.529],
                                                    [-5.396, 5.354],
                                                    [-8.214, -1.169]
                                                ],
                                                "o": [
                                                    [10.073, 10.042],
                                                    [1.2, 8.196],
                                                    [-5.335, 5.36],
                                                    [-11.511, -1.649],
                                                    [-10.073, -10.042],
                                                    [-1.199, -8.196],
                                                    [5.336, -5.36],
                                                    [11.511, 1.649]
                                                ],
                                                "v": [
                                                    [21.197, -21.197],
                                                    [39.183, 12.383],
                                                    [33.907, 33.913],
                                                    [12.384, 39.201],
                                                    [-21.19, 21.197],
                                                    [-39.176, -12.383],
                                                    [-33.9, -33.913],
                                                    [-12.377, -39.201]
                                                ],
                                                "c": true
                                            }
                                        ]
                                    },
                                    {
                                        "i": { "x": 0.833, "y": 0.833 },
                                        "o": { "x": 0.167, "y": 0.167 },
                                        "t": 22,
                                        "s": [
                                            {
                                                "i": [
                                                    [-6.812, -6.792],
                                                    [-1.144, -7.814],
                                                    [3.617, -3.634],
                                                    [5.571, 0.798],
                                                    [6.812, 6.792],
                                                    [1.143, 7.814],
                                                    [-3.638, 3.654],
                                                    [-5.571, -0.798]
                                                ],
                                                "o": [
                                                    [6.833, 6.812],
                                                    [0.814, 5.56],
                                                    [-3.619, 3.636],
                                                    [-7.808, -1.118],
                                                    [-6.833, -6.812],
                                                    [-0.813, -5.56],
                                                    [3.62, -3.636],
                                                    [7.809, 1.118]
                                                ],
                                                "v": [
                                                    [42.651, -42.655],
                                                    [54.852, -19.876],
                                                    [51.273, -5.271],
                                                    [36.673, -1.684],
                                                    [13.897, -13.897],
                                                    [1.696, -36.676],
                                                    [5.275, -51.281],
                                                    [19.876, -54.868]
                                                ],
                                                "c": true
                                            }
                                        ]
                                    },
                                    {
                                        "i": { "x": 0.833, "y": 0.833 },
                                        "o": { "x": 0.167, "y": 0.167 },
                                        "t": 39,
                                        "s": [
                                            {
                                                "i": [
                                                    [-6.812, -6.792],
                                                    [-1.144, -7.814],
                                                    [3.617, -3.634],
                                                    [5.571, 0.798],
                                                    [6.812, 6.792],
                                                    [1.143, 7.814],
                                                    [-3.638, 3.654],
                                                    [-5.571, -0.798]
                                                ],
                                                "o": [
                                                    [6.833, 6.812],
                                                    [0.814, 5.56],
                                                    [-3.619, 3.636],
                                                    [-7.808, -1.118],
                                                    [-6.833, -6.812],
                                                    [-0.813, -5.56],
                                                    [3.62, -3.636],
                                                    [7.809, 1.118]
                                                ],
                                                "v": [
                                                    [42.651, -42.655],
                                                    [54.852, -19.876],
                                                    [51.273, -5.271],
                                                    [36.673, -1.684],
                                                    [13.897, -13.897],
                                                    [1.696, -36.676],
                                                    [5.275, -51.281],
                                                    [19.876, -54.868]
                                                ],
                                                "c": true
                                            }
                                        ]
                                    },
                                    {
                                        "i": { "x": 0.833, "y": 0.833 },
                                        "o": { "x": 0.167, "y": 0.167 },
                                        "t": 45,
                                        "s": [
                                            {
                                                "i": [
                                                    [-5.459, -5.443],
                                                    [0.551, -5.724],
                                                    [2.899, -2.912],
                                                    [4.384, -1.059],
                                                    [5.459, 5.443],
                                                    [-2.14, 7.919],
                                                    [-2.915, 2.928],
                                                    [-4.447, 0.749]
                                                ],
                                                "o": [
                                                    [5.475, 5.459],
                                                    [-0.432, 4.482],
                                                    [-2.9, 2.914],
                                                    [-7.513, 1.814],
                                                    [-5.475, -5.459],
                                                    [1.505, -5.568],
                                                    [2.901, -2.914],
                                                    [5.068, -0.854]
                                                ],
                                                "v": [
                                                    [42.03, -41.914],
                                                    [47.213, -23.426],
                                                    [42.424, -13.691],
                                                    [32.419, -7.849],
                                                    [13.283, -13.261],
                                                    [7.163, -32.397],
                                                    [13.582, -42.317],
                                                    [23.587, -47.725]
                                                ],
                                                "c": true
                                            }
                                        ]
                                    },
                                    {
                                        "i": { "x": 0.833, "y": 0.833 },
                                        "o": { "x": 0.167, "y": 0.167 },
                                        "t": 50,
                                        "s": [
                                            {
                                                "i": [
                                                    [-6.812, -6.792],
                                                    [-1.144, -7.814],
                                                    [3.617, -3.634],
                                                    [5.571, 0.798],
                                                    [6.812, 6.792],
                                                    [1.143, 7.814],
                                                    [-3.638, 3.654],
                                                    [-5.571, -0.798]
                                                ],
                                                "o": [
                                                    [6.833, 6.812],
                                                    [0.814, 5.56],
                                                    [-3.619, 3.636],
                                                    [-7.808, -1.118],
                                                    [-6.833, -6.812],
                                                    [-0.813, -5.56],
                                                    [3.62, -3.636],
                                                    [7.809, 1.118]
                                                ],
                                                "v": [
                                                    [42.651, -42.655],
                                                    [54.852, -19.876],
                                                    [51.273, -5.271],
                                                    [36.673, -1.684],
                                                    [13.897, -13.897],
                                                    [1.696, -36.676],
                                                    [5.275, -51.281],
                                                    [19.876, -54.868]
                                                ],
                                                "c": true
                                            }
                                        ]
                                    },
                                    {
                                        "i": { "x": 0.25, "y": 1 },
                                        "o": { "x": 0.75, "y": 0 },
                                        "t": 53,
                                        "s": [
                                            {
                                                "i": [
                                                    [-6.812, -6.792],
                                                    [-1.144, -7.814],
                                                    [3.617, -3.634],
                                                    [5.571, 0.798],
                                                    [6.812, 6.792],
                                                    [1.143, 7.814],
                                                    [-3.638, 3.654],
                                                    [-5.571, -0.798]
                                                ],
                                                "o": [
                                                    [6.833, 6.812],
                                                    [0.814, 5.56],
                                                    [-3.619, 3.636],
                                                    [-7.808, -1.118],
                                                    [-6.833, -6.812],
                                                    [-0.813, -5.56],
                                                    [3.62, -3.636],
                                                    [7.809, 1.118]
                                                ],
                                                "v": [
                                                    [42.651, -42.655],
                                                    [54.852, -19.876],
                                                    [51.273, -5.271],
                                                    [36.673, -1.684],
                                                    [13.897, -13.897],
                                                    [1.696, -36.676],
                                                    [5.275, -51.281],
                                                    [19.876, -54.868]
                                                ],
                                                "c": true
                                            }
                                        ]
                                    },
                                    {
                                        "t": 71,
                                        "s": [
                                            {
                                                "i": [
                                                    [-10.012, -10.042],
                                                    [-1.618, -11.529],
                                                    [5.336, -5.354],
                                                    [8.214, 1.169],
                                                    [10.013, 10.042],
                                                    [1.619, 11.529],
                                                    [-5.396, 5.354],
                                                    [-8.214, -1.169]
                                                ],
                                                "o": [
                                                    [10.073, 10.042],
                                                    [1.2, 8.196],
                                                    [-5.335, 5.36],
                                                    [-11.511, -1.649],
                                                    [-10.073, -10.042],
                                                    [-1.199, -8.196],
                                                    [5.336, -5.36],
                                                    [11.511, 1.649]
                                                ],
                                                "v": [
                                                    [21.197, -21.197],
                                                    [39.183, 12.383],
                                                    [33.907, 33.913],
                                                    [12.384, 39.201],
                                                    [-21.19, 21.197],
                                                    [-39.176, -12.383],
                                                    [-33.9, -33.913],
                                                    [-12.377, -39.201]
                                                ],
                                                "c": true
                                            }
                                        ]
                                    }
                                ],
                                "ix": 2
                            },
                            "nm": "Path 1",
                            "mn": "ADBE Vector Shape - Group",
                            "hd": false
                        },
                        {
                            "ty": "st",
                            "c": {
                                "a": 0,
                                "k": [0.157, 0.176, 0.212, 1],
                                "ix": 3,
                                "x": "var $bm_rt;\n$bm_rt = thisComp.layer('Main Stroke width - Color Ctrl').effect('Highlight')('Color');"
                            },
                            "o": { "a": 0, "k": 100, "ix": 4 },
                            "w": {
                                "a": 0,
                                "k": 22,
                                "ix": 5,
                                "x": "var $bm_rt;\n$bm_rt = thisComp.layer('Main Stroke width - Color Ctrl').effect('Stroke width')('Slider');"
                            },
                            "lc": 1,
                            "lj": 2,
                            "bm": 0,
                            "nm": "Stroke 1",
                            "mn": "ADBE Vector Graphic - Stroke",
                            "hd": false
                        },
                        {
                            "ty": "tr",
                            "p": { "a": 0, "k": [157.279, 342.722], "ix": 2 },
                            "a": { "a": 0, "k": [0, 0], "ix": 1 },
                            "s": { "a": 0, "k": [100, 100], "ix": 3 },
                            "r": { "a": 0, "k": 0, "ix": 6 },
                            "o": { "a": 0, "k": 100, "ix": 7 },
                            "sk": { "a": 0, "k": 0, "ix": 4 },
                            "sa": { "a": 0, "k": 0, "ix": 5 },
                            "nm": "Transform"
                        }
                    ],
                    "nm": "Group 3",
                    "np": 2,
                    "cix": 2,
                    "bm": 0,
                    "ix": 3,
                    "mn": "ADBE Vector Group",
                    "hd": false
                }
            ],
            "ip": 0,
            "op": 72,
            "st": 0,
            "bm": 0
        }
    ],
    "markers": []
}
